import type { ButtonHTMLAttributes } from 'react';

import { cx } from '../../lib/cx';
import { Icon, type IconName } from '../Icon';

import styles from './IconButton.module.css';

export type IconButtonVariant = 'primary' | 'secondary' | 'tonal' | 'neutral' | 'ghost';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'aria-label'> {
  icon: IconName;
  /** What the button does: its only name, since it shows no text. */
  label: string;
  variant?: IconButtonVariant;
  pressed?: boolean;
}

/** A round button with one icon: 36, 40 or 44 px, by device. */
export function IconButton({
  icon,
  label,
  variant = 'neutral',
  pressed,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      className={cx(styles.button, styles[variant], className)}
      aria-label={label}
      title={label}
      aria-pressed={pressed}
      data-variant={variant}
      {...rest}
    >
      <Icon name={icon} size="var(--hs-icon-button-icon)" />
    </button>
  );
}
